import {Route, RouteProps} from 'react-router-dom';
import {useAuth} from '../../contexts/auth/context';
import MissingAccessScreen from '../missing-access-screen';
import PermissionsRequiredRoute from '../permissions-required-route';
import {Permission} from '../../backend/interfaces/permission';

interface AccessRequiredRouteProps extends RouteProps {
  access: 'digital_inclusion' | 'care_management';
  entityId?: string;
  requiredPermissions?: Permission[];
}

const AccessRequiredRoute = ({
  access,
  entityId,
  requiredPermissions,
  ...rest
}: AccessRequiredRouteProps) => {
  const {
    state: {
      session: {
        selectedAffiliation: {
          contractsOverview: {
            includesDigitalCareManagement = false,
            includesDigitalInclusion = false,
          } = {},
        } = {},
      } = {},
    } = {},
  } = useAuth();

  if (
    (includesDigitalInclusion && access === 'digital_inclusion') ||
    (includesDigitalCareManagement && access === 'care_management')
  ) {
    if (requiredPermissions) {
      return <PermissionsRequiredRoute requiredPermissions={requiredPermissions} {...rest} />;
    }

    return <Route {...rest} />;
  }

  return <MissingAccessScreen denied={access}></MissingAccessScreen>;
};

export default AccessRequiredRoute;
